export default "__VITE_ASSET__204ab280__"